import {cloneDeep} from 'lodash'
import {component_tool} from '@/tool'

const {WizBrowserExport} = component_tool;

const handleFile = (columns = [], title = '未知业务', nextProps, nextState, key) => {
  const o = nextProps[key]

  const exportItem = columns
    .filter(item => !!item?.tableItem || !!item?.exportItem)
    .map(item => {
      const {title, name, dict: dictList = [], tableItem, exportItem} = item;
      const {
        title: title_tableItem,
        type: type_tableItem,
        render: render_tableItem,
        dataIndex: dataIndex_tableItem,
      } = tableItem || {};
      const {
        title: title_exportItem,
        type: type_exportItem,
        render: render_exportItem,
        dataIndex: dataIndex_exportItem,
        ...otherProps
      } = exportItem || {};

      const field = dataIndex_exportItem || dataIndex_tableItem || name
      const type = type_exportItem || type_tableItem || (dictList?.length ? 'select' : 'input')
      // console.log('handleFile map', field, type, type_exportItem, tableItem, type_tableItem, exportItem)

      let render = (item) => item?.[field];
      if (type === 'hidden') {
        return;
      } else if (type === 'custom' || render_exportItem || render_tableItem) {
        // console.log('handleFile custom:', field, render_exportItem, render_tableItem);
        render = (item) => {
          const val = item?.[field];

          // console.log(field, 'item', item, 'val', val, 'render_exportItem', render_exportItem, 'render_tableItem', render_tableItem)
          if (render_exportItem) {
            return render_exportItem(val, item);
          } else if (render_tableItem) {
            return render_tableItem(val, item);
          }
          return val;
        }
      } else if (type === 'select') {
        render = (item) => dictList?.filter(dict => dict?.code === item?.[field]).map(dict => dict?.codeName)?.[0];
      } else if (type === 'checkbox') {
        render = (item) => dictList?.filter(dict => item?.[field]?.indexOf(dict?.code) !== -1).map(dict => dict?.codeName)?.join(',');
      }

      return {
        name: title_exportItem || title_tableItem || title,
        field,
        render,
        otherProps,
      }
    })

  console.log('handleFile exportItem:', exportItem)
  console.table(exportItem)

  let columnDefs = exportItem?.map(({field, name, render, otherProps}) => {
    return {
      headerName: name,
      field,
      width: 20,
      cellStyle: {
        textAlign: 'center',
      },
      style: {
        alignment: {vertical: 'middle', horizontal: 'left', wrapText: true},
      },
      ...otherProps,
    }
  })

  if (o['success']) {
    const data = Object.assign([], o['data'])

    data.forEach((val, index) => {
      const _val = cloneDeep(val)
      exportItem.forEach(item => {
        const {field, render} = item
        // console.log('field', field, val[_val], render(_val))
        val[field] = render ? render(_val) : _val[field]
      })
      // console.log('val:', val)
    })

    WizBrowserExport({
      title: title,
      sheetName: title,
      columns: columnDefs,
      rows: data,
      filename: title + '.xlsx',
    })
    return true;
  } else {
    wizNotice.error(o['msg'])
    return false;
  }
}
export default handleFile
